import { BASE_URL, COMPANY_JOB } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import {
  ICompanyJob,
  ICompanyJobInput,
  ICompanyJobInputEdit,
} from "models/companyJob";

export async function getCompanyJobs(
  params: string = ""
): Promise<ICompanyJob[]> {
  const response = await axios.get(BASE_URL + COMPANY_JOB + params);
  return response.data;
}
export async function addCompanyJob(data: ICompanyJobInput) {
  const response = await axios.post(BASE_URL + COMPANY_JOB, data);
  return response.data;
}

export async function editCompanyJob(data: ICompanyJobInputEdit, id: string) {
  const response = await axios.patch(BASE_URL + COMPANY_JOB + "/" + id, data);
  return response.data;
}

export async function deleteCompanyJob(id: string) {
  const response = await axios.delete(BASE_URL + COMPANY_JOB + "/" + id);
  return response.data;
}

export const CompanyJobsCells: HeadCell[] = [
  {
    id: "companyDepartmentId",
    numeric: false,
    disablePadding: false,
    label: "T_department",
  },
  // {
  //   id: "departmentNameAr",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "T_department_Ar",
  // },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_job",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_job_Ar",
  },
  // {
  //   id: "customTitle",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "T_customTitle",
  // },
  // {
  //   id: "customTitleAr",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "T_customTitle_Ar",
  // },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
